import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Modal } from "antd";
import {
  HomeOutlined,
  CarOutlined,
  EuroCircleOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import EditableTablePassive from "./tableEditablePassive";
import numeral from "numeral";
import ModalAddPassive from "./modalAddPassive";
import {
  createAsset,
  getAsset,
  renameAsset,
  deleteAsset,
} from "../../../store/data/actions";

const { Text } = Typography;
const { confirm } = Modal;

function TablePassive() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [valueTotal, setValueTotal] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);
  const [dataEdit, setDataEdit] = useState();
  const assetList = useSelector((state) => state.data.assetList);
  const userToken = useSelector((state) => state.auth.token);

  const hideAddTaskModal = () => {
    setShowAddModal(false);
    setDataEdit(null);
  };

  const [typeActive, setTypeActive] = useState([
    {
      name: "balance.realeStateTitle",
      category: "realestate",
      icon: <HomeOutlined />,
      dataSource: [],
    },
    {
      name: "balance.furniture",
      category: "vehicles",
      icon: <CarOutlined />,
      dataSource: [],
    },
    {
      name: "form.others",
      category: "other",
      icon: <EuroCircleOutlined />,
      dataSource: [],
    },
  ]);

  useEffect(() => {
    let total = 0;
    typeActive.forEach((type) => {
      type.dataSource.forEach((dataSource) => {
        total += parseInt(dataSource.pending);
      });
    });
    setValueTotal(total);
  }, [typeActive]);

  useEffect(() => {
    dispatch(getAsset(userToken));
  }, []);

  useEffect(() => {
    if (assetList.length > 0) {
      let newTypeActive = [...typeActive].map((type) => {
        return {
          name: type.name,
          category: type.category,
          icon: type.icon,
          dataSource: [],
        };
      });
      assetList.forEach((item) => {
        const dataToAdd = {
          name: item.name,
          pending: item.amount,
          id: item.id,
          term: item.term,
          interest: item.rate,
        };
        if (item.type === "liability") {
          newTypeActive
            .find((data) => {
              return data.category === item.category;
            })
            .dataSource.push(dataToAdd);
        }
      });
      setTypeActive(newTypeActive);
    }
  }, [assetList]);

  const taskEditHandler = (indexType, id) => {
    let newDataSource = [...typeActive][indexType].dataSource.find(
      (item) => item.id === id
    );
    setDataEdit({ ...newDataSource });
  };

  const title = {
    0: "balance.realeStateTitle",
    1: "balance.furniture",
    2: "balance.treasury",
    3: "balance.investments",
  };

  const showDeleteConfirm = (i, id) => {
    confirm({
      className: "ModalCommonConfirm",
      title: `Borrar activos de ${t(title[i])}`,
      icon: null,
      content: "¿Seguro que deseas borrar este elemento?",
      okText: "Borrar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk() {
        handleDelete(i, id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleDelete = (indexType, id) => {
    dispatch(deleteAsset(userToken, id));
  };

  const handleAdd = (values) => {
    if (dataEdit) {
      dispatch(
        renameAsset(
          userToken,
          {
            name: values.name,
            rate: values.interest,
            term: values.term,
            amount: values.pending,
          },
          dataEdit.id
        )
      );
    } else {
      let objResponse = {
        name: values.name,
        amount: values.pending,
        category: t(typeActive[showAddModal].category),
        type: "liability",
        rate: values.interest,
        term: values.term,
      };
      dispatch(createAsset(userToken, objResponse));
    }

    setShowAddModal(false);
    setDataEdit(null);
  };

  return (
    <>
      <div style={{ marginTop: "40px" }}>
        <Text style={{ color: "#2F4858", fontSize: "14px", fontWeight: "500" }}>
          {t("balance.passiveTitle")}
        </Text>
        <Text style={{ color: "#748EA0", fontSize: "14px" }}>
          {" "}
          {t("balance.explinationPassive")}
        </Text>
      </div>

      <div
        style={{
          backgroundColor: "#41D2DA",
          borderRadius: "4px 4px 0px 0px",
          height: "44px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          padding: "16px",
          marginTop: "16px",
        }}
      >
        <Text
          style={{
            width: "30%",
            fontSize: "12px",
            color: "#FFFFFF",
            marginRight: "16px",
            fontWeight: "600",
          }}
        >
          {t("balance.categoryActivePassive")}
        </Text>
        <Text
          style={{
            width: "30%",
            fontSize: "12px",
            color: "#FFFFFF",
            marginRight: "16px",
            fontWeight: "600",
          }}
        >
          {t("form.name")}
        </Text>
        <Text
          style={{
            width: "30%",
            fontSize: "12px",
            color: "#FFFFFF",
            marginRight: "16px",
            fontWeight: "600",
          }}
        >
          {t("scoring.term")}
        </Text>
        <Text
          style={{
            width: "10%",
            fontSize: "12px",
            color: "#FFFFFF",
            marginRight: "16px",
            fontWeight: "600",
          }}
        >
          {t("balance.interest")}
        </Text>
        <Text
          style={{
            width: "14%",
            fontSize: "12px",
            color: "#FFFFFF",
            marginRight: "8px",
            fontWeight: "600",
          }}
        >
          {t("balance.pending")}
        </Text>
      </div>
      {typeActive
        ? typeActive.map((data, i) => {
            return (
              <>
                <EditableTablePassive
                  key={data.name}
                  name={t(data.name)}
                  icon={data.icon}
                  dataToSource={data.dataSource}
                  handleDelete={(id) => handleDelete(i, id)}
                  showAddModal={() => setShowAddModal(i)}
                  taskEditHandler={(id) => taskEditHandler(i, id)}
                  showDeleteConfirm={(id) => showDeleteConfirm(i, id)}
                  index={i}
                />
                {i !== 2 ? (
                  <div
                    style={{
                      marginTop: "-1px",
                      border: "1px solid #F1F7F8",
                    }}
                  />
                ) : null}
              </>
            );
          })
        : null}

      <div
        style={{
          backgroundColor: "#41D2DA",
          borderRadius: "0px 0px 4px 4px",
          height: "44px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
        }}
      >
        <Text
          style={{
            width: "156px",
            fontSize: "12px",
            color: "#FFFFFF",
            marginRight: "16px",
            fontWeight: "600",
          }}
        >
          {t("balance.totalTitle")}
        </Text>
        <Text
          style={{
            fontSize: "16px",
            color: "#FFFFFF",
            marginRight: "10px",
            fontWeight: "600",
          }}
        >
          {valueTotal && numeral(valueTotal).format("0,0 $")}
        </Text>
        <ModalAddPassive
          key={dataEdit}
          visible={showAddModal || dataEdit || showAddModal === 0}
          onCreate={(event) => handleAdd(event)}
          onCancel={hideAddTaskModal}
          width={800}
          dataEdit={dataEdit}
          showAddModal={showAddModal}
        />
      </div>
    </>
  );
}

export default TablePassive;
